module.exports = __webpack_public_path__ + "assets/more-options.d45b1388.svg";